import { getAmplitudeInstance } from '../amplitudeHelpers';
import SignUpScreenDismissedType from '../enums/SignUpScreenDismissedType';

type logSignUpScreenDismissedParams = {
  signup_screen_dismissed_type?: SignUpScreenDismissedType;
};

/**
 * The sign up screen is dismissed by a user clicking 'x' or swiping down.
 * @param params - Attributes to log with the amplitude event
 * @param params.signup_screen_dismissed_type - How the user dismissed the sign up screen
 */
const logSignUpScreenDismissed = ({ signup_screen_dismissed_type }: logSignUpScreenDismissedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('sign up screen dismissed', { 'signup screen dismissed type': signup_screen_dismissed_type }, callback);
};

export default logSignUpScreenDismissed;
